import * as React from 'react'
import Checkbox from '@mui/material/Checkbox'
import Radio from '@mui/material/Radio'
import FormHelperText from '@mui/material/FormHelperText'
import { useController, useFormContext } from 'react-hook-form'

import * as styles from './ListSelect.module.scss'

export const ListSelect = ({
  name,
  label,
  options = [],
  required,
  disabled,
  error,
  fieldStyle,
  multiple = true,
}) => {
  const { control } = useFormContext()
  const { field } = useController({ name, control })

  const value = field.value ?? (multiple ? [] : '')
  const selected = multiple ? (Array.isArray(value) ? value : []) : value

  const toggle = optionValue => {
    if (multiple) {
      const next = selected.includes(optionValue)
        ? selected.filter(item => item !== optionValue)
        : [...selected, optionValue]
      field.onChange(next)
    } else {
      field.onChange(optionValue)
    }
  }

  return (
    <div className={styles.listWrapper} style={fieldStyle}>
      {!!label && (
        <div className={styles.label}>
          {label}
          {required ? <span className={styles.asterisk}>*</span> : null}
        </div>
      )}
      <div className={styles.list}>
        {options.map(option => {
          const checked = multiple
            ? selected.includes(option.value)
            : selected === option.value
          return (
            <button
              key={option.value}
              type="button"
              className={styles.optionRow}
              onClick={() => toggle(option.value)}
              disabled={disabled}
            >
              <span className={styles.control}>
                {multiple ? (
                  <Checkbox size="small" checked={checked} />
                ) : (
                  <Radio size="small" checked={checked} />
                )}
              </span>
              <span className={styles.optionLabel}>{option.label}</span>
            </button>
          )
        })}
      </div>
      {error && (
        <FormHelperText className={styles.error} error={!!error}>
          {error.message}
        </FormHelperText>
      )}
    </div>
  )
}

